export function CookiesPage() {
  return (
    <section className="section-padding bg-white">
      <div className="container-narrow">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-neutral-900 mb-8">
          Cookie Policy
        </h1>

        <div className="prose prose-neutral max-w-none">
          <p className="text-neutral-600">
            Questo sito utilizza cookie e tecnologie simili per garantire il corretto
            funzionamento delle procedure e migliorare l'esperienza di uso delle applicazioni online.
          </p>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Cosa sono i cookie
          </h2>
          <p className="text-neutral-600">
            I cookie sono piccoli file di testo che i siti visitati dagli utenti inviano ai
            loro terminali, dove vengono memorizzati per essere poi ritrasmessi agli stessi
            siti alla visita successiva.
          </p>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Tipologie di cookie utilizzati
          </h2>

          <h3 className="text-xl font-heading font-semibold text-neutral-900 mt-6 mb-3">
            Cookie tecnici
          </h3>
          <p className="text-neutral-600">
            Sono necessari per il corretto funzionamento del sito e non richiedono consenso.
            Include cookie per la memorizzazione della preferenza della lingua.
          </p>

          <h3 className="text-xl font-heading font-semibold text-neutral-900 mt-6 mb-3">
            Cookie di terze parti
          </h3>
          <p className="text-neutral-600">
            Questo sito utilizza servizi di terze parti che potrebbero installare cookie:
          </p>
          <ul className="list-disc pl-6 text-neutral-600 space-y-2">
            <li>Google Analytics (statistiche di navigazione)</li>
            <li>Social media buttons (Facebook, Instagram)</li>
          </ul>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Gestione dei cookie
          </h2>
          <p className="text-neutral-600">
            Puoi gestire le tue preferenze sui cookie attraverso le impostazioni del tuo browser.
            Di seguito i link alle istruzioni per i principali browser:
          </p>
          <ul className="list-disc pl-6 text-neutral-600 space-y-2">
            <li><a href="https://support.google.com/chrome" className="text-brand hover:underline">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org" className="text-brand hover:underline">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/safari" className="text-brand hover:underline">Safari</a></li>
            <li><a href="https://support.microsoft.com/edge" className="text-brand hover:underline">Microsoft Edge</a></li>
          </ul>

          <h2 className="text-2xl font-heading font-semibold text-neutral-900 mt-8 mb-4">
            Aggiornamenti
          </h2>
          <p className="text-neutral-600">
            La presente Cookie Policy può essere aggiornata periodicamente. Ti invitiamo
            a consultare regolarmente questa pagina per essere sempre informato sulle
            modalità di utilizzo dei cookie.
          </p>
        </div>
      </div>
    </section>
  )
}
